import Swal from "sweetalert2";
import EnvConfig from "../environments/envConfig";
import axios from 'axios';

const env = new EnvConfig();
const lcRefresh = "refresh-token"
const lcToken = "tk-jos";
const lcUser = "userId";
const lcUsername = "username";
const lcExpiredDate = "token_expired_date";
const lcRoleId = "role_id";
const lcEmpId = "employee_id";
const lcRoleCode = "role_code";
const lcRoleName = "role_name";
const prem_tree_en = "permission_tree_encoded"
const perm_sig = "permission_signature"

export const logsRequest = (body: any) => {
    console.log("request: ");
    console.log(body);
}

export const logsPath = (method: string, path: string) => {
    console.log(`${method}: ${path}`);
}

export const logsResult = (result: any) => {
    console.log("Result: ");
    console.log(result);
}

export const giveAccessDenied = (extraStep: boolean = false) => {
    localStorage.clear();

    if (extraStep) {
        Swal.fire({
            title: "Token Invalid",
            text: "Token ผิดหรือหมดอายุ กรุณา Login ใหม่อีกครั้ง",
            icon: "error",
            confirmButtonText: "ตกลง"
        }).then(() => {
            window.location.href = "/login";
        });
    } else {
        window.location.href = "/login";
    }
};


export const logout = () => {
    localStorage.clear();
    window.location.href = env.login_page;
}

export const saveRefreshToken = (token: string) => {
    localStorage.setItem(lcRefresh, token)
}

export const saveTokenToLocal = (token: string) => {
    localStorage.setItem(lcToken, token);
}

export const saveUserIdToLocal = (user_id: string) => {
    localStorage.setItem(lcUser, user_id);
}

export const saveUsernameToLocal = (username: string) => {
    localStorage.setItem(lcUsername, username);
}

export const saveTokenExpiredDateToLocal = (expiredDate: string) => {
    localStorage.setItem(lcExpiredDate, expiredDate);
}

export const saveRoleIdToLocal = (role_id: string) => {
    localStorage.setItem(lcRoleId, role_id);
}

export const saveRoleCodeToLocal = (role_code: string) => {
    localStorage.setItem(lcRoleCode, role_code);
}

export const saveRoleNameToLocal = (role_name: string) => {
    localStorage.setItem(lcRoleName, role_name);
}

export const saveEmpIdToLocal = (employee_id: string) => {
    localStorage.setItem(lcEmpId, employee_id);
}

export const savePermTree = (perm_tree: string) => {
    localStorage.setItem(prem_tree_en, perm_tree)
}

export const saveSignaturePermTree = (signature: string) => {
    localStorage.setItem(perm_sig, signature)
}

export const getSignaturePermTree = () => {
    return localStorage.getItem(perm_sig)
}

export const saveGroupId = (group_id: string) => {
    localStorage.setItem("group_id", group_id)
}

export const getTokenRefresh = () => {
    return localStorage.getItem(lcRefresh)
}

export const getTokenFromLocal = () => {
    return localStorage.getItem(lcToken);
}

export const getUserIdFromLocal = () => {
    return localStorage.getItem(lcUser);
}

export const getUsernameLocal = () => {
    return localStorage.getItem(lcUsername);
}

export const getTokenExpiredDateLocal = () => {
    return localStorage.getItem(lcExpiredDate);
}

export const getRoleId = () => {
    return localStorage.getItem(lcRoleId);
}

export const getRoleCode = () => {
    return localStorage.getItem(lcRoleCode);
}

export const getRoleName = () => {
    return localStorage.getItem(lcRoleName);
}

export const getEmpId = () => {
    return localStorage.getItem(lcEmpId);
}

export const getGroupId = () => {
    return localStorage.getItem("group_id")
}

export const deleteTokenFromLocal = () => {
    localStorage.clear();
}



// export const logout_token_api = axios.post({ //------------
//     baseURL: env.logout_token_api,
//     headers: {
//         "Content-Type": "application/json",
//     },
// });

export const destroyToken = async () => {
    try {
        const env = new EnvConfig();
        const refreshToken = getTokenRefresh();
        const token = getTokenFromLocal();

        console.log("=== Logout Debug ===");
        console.log("refreshToken:", refreshToken);
        console.log("API URL:", `${env.front_api}/logout`);

        if (refreshToken && token) {
            const response = await axios.post(`${env.front_api}/logout`, {
                refresh_token: refreshToken
            });
            console.log("Logout Response:", response.data);
            return response;
        } else {
            console.log("No token found, skip API call");
        }
    } catch (error) {
        console.error("Logout Error:", error);
    }
}

export const getPermTree = () => {
    const perm_tree = localStorage.getItem(prem_tree_en);
    if (!perm_tree) {
        return
    }
    const jsonStr = atob(perm_tree);
    const moduleTree = JSON.parse(jsonStr);
    return moduleTree
}

export const getLastChar = (value: string) => {
    return value[value.length - 1];
}

export const isNumber = (value: any) => {
    return /^\d+$/.test(value);
}

export const validateNumberFormatInput = (value: string) => {
    let lastChar = getLastChar(value);
    if (lastChar === ".") {
        if (value.substring(0, value.length - 1).includes(".")) return false;
        return true;
    } else if (!isNumber(lastChar)) {
        return false;
    } else {
        return true;
    }
}

export const convertImageToBase64 = async (image: File) => {
    return await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(image);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}

export const getStartAndEndOfMonth = () => {
    const now = new Date();
    const start = new Date(now.getFullYear(), now.getMonth(), 1);
    const end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    return [start, end] as [Date, Date];
};

export const getCitizenIdFormat = (input: string) => {
    if (!isNumber(input) || input.length !== 13) return input;
    return `${input.slice(0, 1)}-${input.slice(1, 5)}-${input.slice(5, 10)}-${input.slice(10, 12)}-${input.slice(12)}`;
}

export const getPhoneFormat = (input: string) => {
    if (!input) return "";
    if (input.startsWith("+")) {
        // E.164 format: +<country_code><number>
        // For display, we can try to format it simply
        if (input.startsWith("+66")) {
            const num = input.slice(3);
            if (num.length === 9) {
                return `+66 ${num.slice(0, 2)}-${num.slice(2, 5)}-${num.slice(5)}`;
            }
        }
        return input;
    }
    let inputLen = input.length;
    if (!isNumber(input) || (inputLen !== 10 && inputLen !== 9)) return input;
    let result = "";
    if (inputLen === 10) result = `${input.slice(0, 3)}-${input.slice(3, 6)}-${input.slice(6, 10)}`;
    else result = `${input.slice(0, 2)}-${input.slice(2, 5)}-${input.slice(5, 9)}`;
    return result;
}

export const isPhoneNumber = (input: string) => {
    if (input.startsWith("+")) {
        return /^\+\d{10,15}$/.test(input);
    }
    const phoneRegex = /^0\d{8,9}$/;
    return phoneRegex.test(input);
}

export const toE164 = (countryCode: string, localPhone: string): string => {
    // Remove all non-digits from localPhone
    let cleanLocal = localPhone.replace(/\D/g, "");
    // If it starts with 0, remove the leading 0
    if (cleanLocal.startsWith("0")) {
        cleanLocal = cleanLocal.slice(1);
    }
    return `${countryCode}${cleanLocal}`;
};

export const parseE164 = (e164Phone: string, countryCodes: { value: string }[]) => {
    if (!e164Phone || !e164Phone.startsWith("+")) {
        return { countryCode: "+66", localPhone: e164Phone || "" };
    }

    // Find the longest matching country code
    const sortedCodes = [...countryCodes].sort((a, b) => b.value.length - a.value.length);
    for (const code of sortedCodes) {
        if (e164Phone.startsWith(code.value)) {
            let local = e164Phone.slice(code.value.length);
            // Prepend 0 for Thai numbers if it's not already there and length is 9 (to make it 10)
            if (code.value === "+66" && local.length === 9 && !local.startsWith("0")) {
                local = "0" + local;
            }
            return { countryCode: code.value, localPhone: local };
        }
    }

    return { countryCode: "+66", localPhone: e164Phone };
};

export const isEmail = (input: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(input);
}

export const convertNumStrToNum = (val: string | number | undefined | null): number => {
    if (val === undefined || val === null) return 0; //ผมเพิ่มไว้ดัก ตอนที่ เวลา กดเข้าหน้าแก้ไข แล้วดัน กด ต้นทุนแต่ละจุดส่ง แล้วมันส่งเป็นค่าว่างไป
    return Number(val.toString().replaceAll(",", ""));
};